import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as CloseIcon } from '../../assets/Close-btn.svg';

interface LogoutConfirmationModalProps {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const LogoutConfirmationModal: React.FC<LogoutConfirmationModalProps> = ({ show, onClose, onConfirm }) => {
  const { t } = useTranslation();

  if (!show) return null;

  return (
    <div className='bg-[rgba(25,25,25,0.25)] fixed top-0 left-0 w-full h-full flex items-center justify-center modal-overlay' onClick={onClose} style={{zIndex: 99999}}>
      <div className='bg-white p-5 rounded-[20px] w-[400px] h-fit relative px-[20px] md:px-[45px] pt-[28px] md:pt-[50px] pb-[28px] md:pb-[35px]' onClick={(e) => e.stopPropagation()}>
        
        <div className='flex items-center justify-between mb-[36px] md:mb-[65px]'>
          <div />
          <h1 className='font-semibold leading-none text-center text-[32px] md:text-[45px] tracking-[1px]'>
            {t('navigation.signOut')}
          </h1>
          <button onClick={onClose} className='' aria-label={t('common.close')}>
            <CloseIcon />
          </button>
        </div>
        <p className='text-[#636363] text-[20px] text-center mb-[36px]'>
          {t('auth.confirmLogout')}
        </p>

        <div className='flex flex-col gap-4'>
          <button
            onClick={() => {
              onConfirm();
            }}
            className='h-14 w-full flex items-center justify-center px-6 bg-primary_500 rounded-2xl'
          >
            <span className='semibold-text text-white'>{t('auth.confirm')}</span>
          </button>
          
          <button
            onClick={onClose}
            className='h-14 w-full flex items-center justify-center px-6 bg-white border-2 border-[#00726B] rounded-2xl'
          >
            <span className='semibold-text text-primary_500'>{t('common.cancel')}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogoutConfirmationModal; 